import React from 'react'
import { MISSION_STATEMENT } from './../../content'

import './OurMission.component.scss'

const OurMission = () => (
  <section id='OurMission' className='subsite-section'>
    <div className='subsite-shell'>
      <div className='mission-box'>
        <div className='mission-head'>
          <h2>Our Mission</h2>
        </div>
        <div className='mission-body'>
          <p>{MISSION_STATEMENT}</p>
        </div>
      </div>
    </div>
  </section>
)

export default OurMission
